import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import CustomSelect from '../../ui/CustomSelect';

const statusOptions = [
  { value: 'present', label: 'Hadir' },
  { value: 'late', label: 'Terlambat' },
  { value: 'absent', label: 'Tidak Hadir' },
  { value: 'leave', label: 'Cuti' },
  { value: 'sick', label: 'Sakit' },
  { value: 'holiday', label: 'Libur' },
];

export default function AttendanceModal({
  open,
  editing,
  form,
  setForm,
  employees,
  saving,
  onClose,
  onSave,
}) {
  if (!open) return null;

  const employeeOptions = [
    { value: '', label: 'Pilih pegawai' },
    ...employees.map(emp => ({ value: emp.id, label: `${emp.full_name} (${emp.employee_id})` })),
  ];

  return createPortal(
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-lg w-full max-w-lg max-h-[90vh] overflow-hidden animate-modal">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-semibold">
            {editing ? 'Edit Kehadiran' : 'Tambah Kehadiran'}
          </h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4 space-y-3 max-h-[60vh] overflow-y-auto">
          <div className="space-y-1">
            <label className="text-sm font-medium text-gray-700">
              Pegawai <span className="text-red-500">*</span>
            </label>
            <CustomSelect
              value={form.employee_id}
              onChange={val => setForm({ ...form, employee_id: val })}
              options={employeeOptions}
              placeholder="Pilih pegawai"
              width="w-full"
              disabled={!!editing}
            />
          </div>
          <div className="space-y-1">
            <label className="text-sm font-medium text-gray-700">
              Tanggal <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              value={form.date}
              onChange={e => setForm({ ...form, date: e.target.value })}
              disabled={!!editing}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 disabled:opacity-50"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">Clock In</label>
              <input
                type="time"
                value={form.clock_in}
                onChange={e => setForm({ ...form, clock_in: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">Clock Out</label>
              <input
                type="time"
                value={form.clock_out}
                onChange={e => setForm({ ...form, clock_out: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
            </div>
          </div>
          <div className="space-y-1">
            <label className="text-sm font-medium text-gray-700">
              Status <span className="text-red-500">*</span>
            </label>
            <CustomSelect
              value={form.status}
              onChange={val => setForm({ ...form, status: val })}
              options={statusOptions}
              placeholder="Pilih status"
              width="w-full"
            />
          </div>
          <div className="space-y-1">
            <label className="text-sm font-medium text-gray-700">Catatan</label>
            <input
              type="text"
              value={form.notes}
              onChange={e => setForm({ ...form, notes: e.target.value })}
              placeholder="Catatan tambahan"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
            />
          </div>
        </div>
        <div className="flex justify-end gap-3 p-4 border-t bg-gray-50">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100 font-medium"
          >
            Batal
          </button>
          <button
            onClick={onSave}
            disabled={saving || !form.employee_id || !form.date}
            className="px-4 py-2 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 disabled:opacity-50 font-medium"
          >
            {saving ? 'Menyimpan...' : 'Simpan'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
